<template>
    <svg :class="className" x="0px" y="0px" width="10.9px" height="32.6px" viewBox="0 0 10.9 32.6">
        <path d="M3.7,14.6c0.9-0.9,2.5-0.9,3.5,0c0.5,0.5,0.7,1.1,0.7,1.7h3c0-0.4-0.1-0.9-0.2-1.2L5.8,0.5C5.7,
        0.2,5.6,0,5.4,0C5.4,0,5.3,0,5.2,0.1C5.2,0.2,5.1,0.3,5,0.5L0.2,15.1C0.1,15.4,0,15.9,0,16.3h3C3,15.7,
        3.2,15.1,3.7,14.6z">
        </path>
        <path d="M7.9,16.3c0,0.6-0.2,1.3-0.7,1.7C6.2,19,4.7,19,3.7,18C3.2,17.6,3,16.9,3,16.3H0c0, 0.4,0.1,0.9,
        0.2,1.2L5,32.2c0,0,0,0.1,0,0.1c0.2,0.5,0.6,0.5,0.7-0.1l4.9-14.7c0.1-0.3,0.2-0.7,0.1-1.2H7.9z">
        </path>
    </svg>
</template>

<script>
export default {props: ['className']};
</script>
